/**
 * Transforms an activity offer from the API
 *
 * @param offer The offer containing the activity
 * @returns The activity offer
 */
export function transformOfferActivity(offer: ApiSchema['Offer']): OfferActivity | undefined {
    const passengerRefs = offer.passengerRefs;
    const offerParts = offer.activityOfferParts
        ?.map(aop => ({
            id: aop.id,
            type: 'ActivityOfferPart',
            summary: aop.summary ?? '',
            passengerRefs: aop.passengerRefs,
            price: aop.price,
            promotionCodes: aop.appliedPromotionCodes?.map(transformPromotionCode) ?? [],
        } satisfies OfferPartActivity))
        // Sort by passengerRefs to ensure the order is consistent
        .sort((a, b) => {
            return JSON.stringify(a.passengerRefs) > JSON.stringify(b.passengerRefs) ? 1 : -1;
        }) ?? [];

    return {
        offerId: offer.offerId,
        type: 'Activity',
        passengerRefs,
        offerParts,
    } satisfies OfferActivity;
}
